import { buildCrudRoutes } from '@/app/arch/components/crud/CrudRouter';

const featureBreadCrumps = [
  {
    text: 'Dashboard',
    disabled: false,
    to: 'dashboard',
  },
  {
    text: 'Conta card',
    disabled: false,
    to: 'contacard.submodules.list',
  },
  {
    text: 'Marcas',
    disabled: false,
    to: 'marca.list',
  },
];

export default [
  ...buildCrudRoutes({
    baseName: 'marca.integrador',
    basePath: 'marca/integrador',
    baseBreadcrumbs: featureBreadCrumps,
    moduleActive: 'contacard',
    subModuleActive: 'produto',
    newRoute: {
      component: () => import('Modules/contacard/produto/marca/integrador/MarcaIntegradorForm.vue'),
      breadcrumbs: [
        {
          text: 'Adicionar integrador',
          disabled: true,
        },
      ],
    },
  }),
];
